import React from "react";
import {
  getDataColor,
  getHeaderClasses,
} from "../../../ConsolidatedReportsUtilities";
import {
  findScoreForLesson,
  getGridTemplateColumns,
  getMinWidthOfRows,
  getStandardSetTransitionBorder,
} from "../LearnerScoresTableUtilities";
import LearnerActions from "./LearnerActions";

const LearnerRow = ({
  index,
  filteredLessons,
  handleColumnHeaderClick,
  setSortedLearnerId,
  val,
  setSortedLearnerIdAsc,
  sortedLearnerIdAsc,
  sortedLearnerId,
  nameVals,
  learnersListWithScores,
  hasBorder,
  setSelectedSearchVal,
  setActiveTab,
  setViewLearnerInClass,
  setSortingStandardsAsc,
  showPreferredStandardInfo,
  standardSet,
}) => {
  return (
    <div
      className='reports_row'
      key={index}
      style={{
        backgroundColor: index % 2 === 0 ? "#F2F2F2" : "",
        gridTemplateColumns: getGridTemplateColumns(filteredLessons),
        minWidth: getMinWidthOfRows(filteredLessons),
      }}
    >
      <div
        className='data score name'
        onClick={() => {
          handleColumnHeaderClick(filteredLessons, "learnerAverage");
          setSortedLearnerId(val.sid);
          setSortedLearnerIdAsc(!sortedLearnerIdAsc);
          setSortingStandardsAsc(null);
        }}
      >
        <p
          className={`${getHeaderClasses(
            val.sid,
            sortedLearnerId,
            sortedLearnerIdAsc
          )}`}
        >{`${nameVals.first_name} ${nameVals.last_name}`}</p>
      </div>

      {filteredLessons.length !== 0 ? (
        filteredLessons.map((value, index1) => {
          let lessonScore = findScoreForLesson(
            learnersListWithScores[index].scores,
            filteredLessons[index1].label
          );

          const transitionBorder = getStandardSetTransitionBorder(
            filteredLessons,
            index1,
            standardSet,
            showPreferredStandardInfo
          );

          return (
            <div
              key={index1}
              className={`data score ${getDataColor(lessonScore)}`}
              style={{
                borderRight: hasBorder(index1, filteredLessons.length),
                borderLeft: transitionBorder,
              }}
            >
              {lessonScore !== null ? lessonScore : "-"}
            </div>
          );
        })
      ) : (
        <div className='data score dash'>-</div>
      )}
      {filteredLessons.length <= 15 && filteredLessons.length !== 0 ? (
        <div className='score_hr'></div>
      ) : (
        <div />
      )}
      <div
        className={`data score learner_averages ${getDataColor(val.average)}`}
      >
        <p style={{ fontWeight: "bold" }}>
          {val.average !== null ? val.average : "-"}
        </p>
      </div>

      <LearnerActions
        learner={val}
        sid={val.sid}
        nameVals={nameVals}
        setSelectedSearchVal={setSelectedSearchVal}
        setActiveTab={setActiveTab}
        setViewLearnerInClass={setViewLearnerInClass}
      />
    </div>
  );
};

export default LearnerRow;
